// src/components/ui/Stamp.tsx — Edmondson ticket-style dashed reference badge.
import type { CSSProperties, ReactNode } from "react";
import { C, F } from "../../theme";

export type StampTone = "brass" | "paper" | "signal" | "heather" | "sage";

export interface StampProps {
  tone?: StampTone;
  children: ReactNode;
  style?: CSSProperties;
}

const tones: Record<StampTone, { bg: string; fg: string; bd: string }> = {
  brass:   { bg: "#F6E1A7",    fg: C.brassDk,   bd: "#C9A458" },
  paper:   { bg: "#F2E5C2",    fg: C.inkSoft,   bd: C.hairline },
  signal:  { bg: "#EDC6BC",    fg: C.signalDk,  bd: "#C68679" },
  heather: { bg: C.heatherBg,  fg: C.heatherDk, bd: "#B89BC4" },
  sage:    { bg: C.sageBg,     fg: C.sageDk,    bd: "#9CB39E" },
};

export const Stamp = ({ tone = "brass", children, style }: StampProps) => {
  const t = tones[tone];
  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 8px",
        fontFamily: F.mono,
        fontSize: 11,
        fontWeight: 700,
        color: t.fg,
        background: t.bg,
        border: `1px dashed ${t.bd}`,
        borderRadius: 3,
        letterSpacing: 1,
        ...style,
      }}
    >
      {children}
    </span>
  );
};
